(function(){
  'use strict';

  const RATE_CACHE_KEY='vivonu_fx_zar_v2';
  const RATE_CACHE_TTL=6*60*60*1000;
  const MONEY_SELECTOR='.money';
  let rates={ZAR:1};
  let state={countryCode:'ZA',countryName:'South Africa',currency:'ZAR'};
  let applying=false;
  let refreshTimer=null;

  const localeByCountry={
    ZA:'en-ZA',NA:'en-NA',ZM:'en-ZM',MZ:'pt-MZ',BW:'en-BW',ZW:'en-ZW',LS:'en-LS',SZ:'en-SZ',
    MU:'en-MU',MG:'fr-MG',CV:'pt-CV',KE:'en-KE',GH:'en-GH',SN:'fr-SN',RW:'en-RW',UG:'en-UG',
    MA:'fr-MA',EG:'ar-EG',CI:'fr-CI',NG:'en-NG',AE:'en-AE',AT:'de-AT',AU:'en-AU',BE:'fr-BE',
    CA:'en-CA',CH:'de-CH',CZ:'cs-CZ',DE:'de-DE',DK:'da-DK',ES:'es-ES',FI:'fi-FI',FR:'fr-FR',
    GB:'en-GB',HK:'en-HK',IE:'en-IE',IL:'he-IL',IT:'it-IT',JP:'ja-JP',KR:'ko-KR',MY:'ms-MY',
    NL:'nl-NL',NO:'no-NO',NZ:'en-NZ',PL:'pl-PL',PT:'pt-PT',SE:'sv-SE',SG:'en-SG',US:'en-US',
    SA:'ar-SA',QA:'ar-QA',KW:'ar-KW',BH:'ar-BH',OM:'ar-OM'
  };

  function selectedState(){
    const sel=document.getElementById('VivonuLocationCountry');
    const opt=sel?.selectedOptions?.[0];
    const text=(opt?.textContent||'').trim();
    const match=text.match(/(?:·|\s)([A-Z]{3})\s*$/);
    return {
      countryCode:(opt?.value||'ZA').toUpperCase(),
      countryName:text.split('·')[0]?.trim()||'South Africa',
      currency:(match?.[1]||'ZAR').toUpperCase()
    };
  }

  function flagEmoji(code){
    if(!/^[A-Z]{2}$/.test(code)) return '🌍';
    return String.fromCodePoint(...[...code].map(c=>127397+c.charCodeAt(0)));
  }

  function parseZar(text){
    if(!text) return null;
    let t=String(text).replace(/\u00a0/g,' ').trim();
    if(!/(^|\s)R\s?[\d.,]|ZAR/i.test(t)) return null;
    t=t.replace(/ZAR/ig,'').replace(/[^0-9,.-]/g,'');
    if(!t) return null;
    if(t.includes(',')&&t.includes('.')) t=t.replace(/,/g,'');
    else if((t.match(/,/g)||[]).length===1&&!t.includes('.')){
      const p=t.split(',');
      t=(p[1]||'').length===2?p[0]+'.'+p[1]:p.join('');
    }else{
      t=t.replace(/,/g,'');
    }
    const n=Number(t);
    return Number.isFinite(n)?n:null;
  }

  function format(amount,currency){
    const locale=localeByCountry[state.countryCode]||document.documentElement.lang||'en-ZA';
    const explicit={NAD:'N$',ZWG:'ZWG',LSL:'LSL',SZL:'SZL',ZMW:'ZK',BWP:'P',MZN:'MT'};
    if(explicit[currency]){
      const number=new Intl.NumberFormat(locale,{minimumFractionDigits:2,maximumFractionDigits:2}).format(amount);
      const tight=(currency==='NAD'||currency==='ZMW'||currency==='BWP');
      return explicit[currency]+(tight?'':' ')+number;
    }
    try{
      return new Intl.NumberFormat(locale,{style:'currency',currency,minimumFractionDigits:2,maximumFractionDigits:2}).format(amount);
    }catch(e){
      return currency+' '+amount.toFixed(2);
    }
  }

  function captureBase(el){
    const text=(el.textContent||'').trim();
    if(el.dataset.vivonuRendered===text&&el.dataset.vivonuBaseZar){
      const saved=Number(el.dataset.vivonuBaseZar);
      return Number.isFinite(saved)?saved:null;
    }
    const parsed=parseZar(text);
    if(parsed!==null){
      el.dataset.vivonuBaseZar=String(parsed);
      return parsed;
    }
    const saved=Number(el.dataset.vivonuBaseZar);
    return Number.isFinite(saved)?saved:null;
  }

  function convertElement(el){
    if(!(el instanceof HTMLElement)) return;
    const base=captureBase(el);
    if(base===null) return;
    const rate=Number(rates[state.currency]);
    if(!Number.isFinite(rate)||rate<=0) return;
    const out=state.currency==='ZAR'?format(base,'ZAR'):format(base*rate,state.currency);
    if(el.textContent!==out){
      applying=true;
      el.textContent=out;
      el.dataset.vivonuRendered=out;
      applying=false;
    }
  }

  function ensurePill(){
    let btn=document.getElementById('VivonuCurrencyPill');
    if(btn) return btn;

    btn=document.createElement('button');
    btn.id='VivonuCurrencyPill';
    btn.type='button';
    btn.className='vivonu-currency-pill';
    btn.setAttribute('aria-label','Display currency and delivery country');
    btn.innerHTML='<span class="vivonu-currency-pill__flag" aria-hidden="true"></span><span class="vivonu-currency-pill__code"></span><span class="vivonu-currency-pill__chev" aria-hidden="true">⌄</span>';
    btn.addEventListener('click',()=>document.querySelector('.vivonu-delivery-location-trigger')?.click());
    document.body.appendChild(btn);

    if(!document.getElementById('VivonuUnifiedCurrencyStyle')){
      const style=document.createElement('style');
      style.id='VivonuUnifiedCurrencyStyle';
      style.textContent=`
        #VivonuCurrencyPill.vivonu-currency-pill{
          position:fixed!important;left:30px!important;bottom:20px!important;z-index:2147483000!important;
          min-width:94px!important;min-height:43px!important;display:inline-flex!important;align-items:center!important;
          justify-content:center!important;gap:8px!important;padding:7px 12px!important;border:1.5px solid #d4af37!important;
          border-radius:11px!important;background:#0b2d4a!important;color:#fff!important;
          box-shadow:0 7px 20px rgba(11,45,74,.28)!important;
          font:800 13px/1 Inter,system-ui,sans-serif!important;cursor:pointer!important;opacity:1!important;
          visibility:visible!important;transform:none!important;
        }
        #VivonuCurrencyPill:hover,#VivonuCurrencyPill:focus-visible{background:#123f66!important;outline:2px solid #fff!important;outline-offset:2px!important}
        #VivonuCurrencyPill .vivonu-currency-pill__flag{font-size:22px!important;line-height:1!important}
        #VivonuCurrencyPill .vivonu-currency-pill__code{letter-spacing:.04em!important;color:#fff!important}
        #VivonuCurrencyPill .vivonu-currency-pill__chev{color:#d4af37!important;font-size:14px!important}
        html.vivonu-location-open #VivonuCurrencyPill{opacity:.42!important}
        @media(max-width:620px){
          #VivonuCurrencyPill{left:14px!important;bottom:14px!important;min-width:88px!important;min-height:40px!important;padding:6px 10px!important}
          #VivonuCurrencyPill .vivonu-currency-pill__flag{font-size:20px!important}
        }
      `;
      document.head.appendChild(style);
    }
    return btn;
  }

  function updatePill(){
    const btn=ensurePill();
    btn.querySelector('.vivonu-currency-pill__flag').textContent=flagEmoji(state.countryCode);
    btn.querySelector('.vivonu-currency-pill__code').textContent=state.currency;
    btn.title=state.countryName+' • '+state.currency+' display pricing • checkout may remain ZAR';
  }

  function convertAll(root=document){
    root.querySelectorAll?.(MONEY_SELECTOR).forEach(convertElement);
    if(root.matches?.(MONEY_SELECTOR)) convertElement(root);
    updatePill();
  }

  async function loadRates(){
    const now=Date.now();
    try{
      const cached=JSON.parse(localStorage.getItem(RATE_CACHE_KEY)||'null');
      if(cached?.rates&&cached.savedAt&&now-cached.savedAt<RATE_CACHE_TTL){
        rates=Object.assign({ZAR:1},cached.rates);
        return true;
      }
    }catch(e){}

    const endpoints=['https://open.er-api.com/v6/latest/ZAR','https://api.exchangerate-api.com/v4/latest/ZAR'];
    for(const url of endpoints){
      try{
        const res=await fetch(url,{mode:'cors',cache:'no-store'});
        if(!res.ok) continue;
        const data=await res.json();
        const next=data.rates||data.conversion_rates;
        if(next&&typeof next==='object'){
          rates=Object.assign({ZAR:1},next);
          try{localStorage.setItem(RATE_CACHE_KEY,JSON.stringify({rates,savedAt:now}));}catch(e){}
          return true;
        }
      }catch(e){}
    }
    return false;
  }

  async function init(){
    state=selectedState();
    ensurePill();
    updatePill();

    const ok=await loadRates();
    if(ok||state.currency==='ZAR') convertAll(document);

    [250,650,1400,2600].forEach(ms=>setTimeout(()=>{
      state=selectedState();
      updatePill();
      if(ok||state.currency==='ZAR') convertAll(document);
    },ms));

    const observer=new MutationObserver(mutations=>{
      if(applying) return;
      clearTimeout(refreshTimer);
      refreshTimer=setTimeout(()=>{
        state=selectedState();
        for(const m of mutations){
          if(m.type==='childList'){
            m.addedNodes.forEach(node=>{
              if(node.nodeType===1) convertAll(node);
              else if(node.parentElement?.matches?.(MONEY_SELECTOR)) convertElement(node.parentElement);
            });
          }else if(m.type==='characterData'&&m.target.parentElement?.matches?.(MONEY_SELECTOR)){
            convertElement(m.target.parentElement);
          }
        }
        updatePill();
      },80);
    });
    observer.observe(document.body,{subtree:true,childList:true,characterData:true});
  }

  window.VivonuCurrency={
    refresh:()=>{state=selectedState();updatePill();loadRates().then(()=>convertAll(document));},
    get currency(){return state.currency;},
    get country(){return state.countryCode;}
  };

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();